export const MainPromptVersion = "main";
export const NextPromptVersion = "next";

export const PromptVersions = [MainPromptVersion, NextPromptVersion] as const;
export type PromptVersion = (typeof PromptVersions)[number];
